<ng-select
  [required]="required"
  [items]="items$ | async"
  [multiple]="true"
  [closeOnSelect]="false"
  [searchable]="searchable"
  [bindLabel]="bindLabel"
  [placeholder]="placeholder"
  [(ngModel)]="selected"
  (change)="onChange($event)"
  [disabled]="disabled"
  [ngbTooltip]="tooltip"
  placement="top"
  [notFoundText]="addItem ? 'Type to add a new item' : 'No items found'"
  [addTag]="addItem">
</ng-select>
